import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import useApi from "../../hook/useApi";
import Paggination from "../Paggination";
import Loader from "../Loader/Loader";
import {
  copyToClipboard,
  formatDateInAMPM,
  trimAddress,
} from "../../utils/helper";
import { IoCopyOutline } from "react-icons/io5";
import { BASE_URL, STANDARD_IMAGE_URL } from "../../utils/constant";

const NftMarketplaceLayer = () => {
  const { AsyncGetApiCall, AsyncPostApiCall } = useApi();
  const navigate = useNavigate();
  const [query, setQuery] = useState({
    pageNo: 1,
    limitVal: 50,
    search: "",
    status: "",
  });
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);

  const setPageNo = (pageNo) => {
    setQuery((prev) => ({
      ...prev,
      pageNo: pageNo,
    }));
  };

  const getAllNftList = async (showLoader = true) => {
    try {
      // if (showLoader) {
      setLoading(true);
      // }
      console.log("query...", query);
      const result = await AsyncGetApiCall(
        "/market-place/list-in-admin",
        query
      );
      console.log("Result:", result);

      if (result?.success) {
        setData(result || []);
      } else {
        toast.error(result?.message || "Failed to fetch marketplace data");
      }
    } catch (error) {
      console.log("error...", error);
    } finally {
      // if (showLoader) {
      setLoading(false);
      // }
    }
  };

  const handleSearchAirdrop = (e) => {
    const value = e.target.value;
    const validChars = /^[a-zA-Z0-9]*$/; // Only alphanumeric characters allowed

    if (validChars.test(value)) {
      setQuery((prev) => ({ ...prev, search: value, pageNo: 1 }));
    }
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
  };

  const handleMethodChange = (e) => {
    const value = e.target.value;
    setQuery((prev) => ({
      ...prev,
      method:
        value === ""
          ? ""
          : value === "auction"
          ? "auction"
          : value === "fixed"
          ? "fixed"
          : "",
      pageNo: 1,
    }));
  };

  // Assuming an endpoint like /market-place/approve exists for status change
  // Adjust as per your backend
  // const handleActivateNft = async (id, isApproved) => {
  //   console.log("id...", id);
  //   console.log("isApproved...", isApproved);

  //   try {
  //     setLoading(true);
  //     const payload = {
  //       listingId: id, // Use listing ID
  //       status: isApproved ? "APPROVED" : "REJECTED", // Adjust statuses as per your API
  //     };
  //     const result = await AsyncPostApiCall(
  //       `/market-place/status-manage`,
  //       payload
  //     ); // Hypothetical endpoint
  //     console.log("result...", result);
  //     if (result?.success) {
  //       toast.success(
  //         result?.message ||
  //         `Listing ${isApproved ? "activated" : "deactivated"} successfully`
  //       );
  //       getAllNftList(false);
  //     } else {
  //       toast.error(result?.message || "Something went wrong");
  //     }
  //   } catch (error) {
  //     console.log("error...", error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  useEffect(() => {
    getAllNftList(false);
  }, [query]);

  return (
    <>
      {loading && <Loader />}
      <div className="card h-100 p-0 radius-12">
        <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center flex-wrap gap-3 justify-content-between">
          <div className="d-flex align-items-center flex-wrap gap-3">
            <span className="text-md fw-medium text-secondary-light mb-0">
              Show
            </span>
            <select
              className="form-select form-select-sm w-auto ps-12 py-6 radius-12 h-40-px"
              value={query.limitVal}
              onChange={(e) => {
                const value = parseInt(e.target.value, 10);
                setQuery((prev) => ({
                  ...prev,
                  limitVal: value,
                  pageNo: 1,
                }));
              }}
            >
              {Array.from({ length: 20 }, (_, i) => {
                const value = (i + 1) * 5;
                return (
                  <option key={value} value={value}>
                    {value}
                  </option>
                );
              })}
            </select>
            <form className="navbar-search" onSubmit={handleFormSubmit}>
              <input
                type="text"
                className="bg-base h-40-px w-30"
                name="search"
                placeholder="Search Marketplace by NFT, Collection "
                onChange={handleSearchAirdrop}
                value={query.search}
              />
              <Icon icon="ion:search-outline" className="icon" />
            </form>
            <span className="text-md fw-medium text-secondary-light mb-0">
              Status
            </span>
            <select
              name="method"
              id="method"
              className="form-select form-select-sm w-auto ps-12 py-6 radius-12 h-40-px"
              value={
                query.method === "auction"
                  ? "auction"
                  : query.method === "fixed"
                  ? "fixed"
                  : ""
              }
              onChange={handleMethodChange}
            >
              <option value="">Select Method</option>
              <option value="auction">Auction</option>
              <option value="fixed">Fixed</option>
            </select>
          </div>
        </div>

        <div className="card-body p-24">
          <div className="table-responsive scroll-sm">
            <table className="table bordered-table sm-table mb-0">
              <thead>
                <tr>
                  <th scope="col">
                    <div className="d-flex align-items-center gap-10">
                      <div className="form-check style-check d-flex align-items-center"></div>
                      S.No
                    </div>
                  </th>
                  <th scope="col">NFT Id</th>
                  <th scope="col">Collection Address</th>
                  <th scope="col">Method</th>
                  <th scope="col">Price</th>
                  <th scope="col">Category</th>
                  <th scope="col">Created At</th>
                  <th scope="col" className="text-center">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {data?.data && data?.data?.length > 0 ? (
                  data?.data?.map((listing, index) => (
                    <tr key={listing._id}>
                      <td>
                        <div className="d-flex justify-content-center align-items-center gap-10">
                          {(data?.currentPage - 1) * query.limitVal + index + 1}
                        </div>
                      </td>
                      <td>
                        <span className="text-md mb-0 fw-normal text-secondary-light">
                          <img
                            src={
                              listing?.image
                                ? `${BASE_URL}${listing?.image}`
                                : STANDARD_IMAGE_URL
                            }
                            alt="NFT"
                            className="w-40-px h-40-px flex-shrink-0 me-12 overflow-hidden nft-border-radius"
                          />
                          {trimAddress(listing?.nftId, 3, 3)}
                          <button
                            onClick={() => copyToClipboard(listing?.nftId)}
                            className="ms-3 p-0 border-0 bg-transparent"
                            style={{ lineHeight: 1 }}
                          >
                            <IoCopyOutline />
                          </button>
                        </span>
                      </td>
                      <td>
                        <span className="text-md mb-0 fw-normal text-secondary-light">
                          {trimAddress(listing?.collectionAddress, 3, 3)}
                          <button
                            onClick={() =>
                              copyToClipboard(listing?.collectionAddress)
                            }
                            className="ms-3 p-0 border-0 bg-transparent"
                            style={{ lineHeight: 1 }}
                          >
                            <IoCopyOutline />
                          </button>
                        </span>
                      </td>
                      <td>
                        <span className="text-md mb-0 fw-normal text-secondary-light">
                          {listing?.method || "N/A"}
                        </span>
                      </td>
                      <td>
                        <span className="text-md mb-0 fw-normal text-secondary-light">
                          {/* {listing?.method === "FIXED" ? `${listing?.fixedDetails?.price} ETH` : `${listing?.auctionDetails?.minBid} ETH` || "N/A"} */}
                          {listing?.method === "FIXED"
                            ? `${listing?.fixedDetails?.price || "0"} ETH`
                            : listing?.method === "AUCTION"
                            ? `${listing?.auctionDetails?.minBid || "0"} ETH`
                            : "N/A"}
                        </span>
                      </td>
                      <td>
                        <span className="text-md mb-0 fw-normal text-secondary-light">
                          {listing?.category}
                        </span>
                      </td>
                      <td>
                        <span className="text-md mb-0 fw-normal text-secondary-light">
                          {formatDateInAMPM(listing?.createdAt)}
                        </span>
                      </td>
                      <td className="text-center">
                        <div className="d-flex align-items-center gap-10 justify-content-center">
                          <button
                            type="button"
                            className="bg-info-focus bg-hover-info-200 text-info-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                            onClick={() =>
                              navigate(`/nft-marketplace-view/${listing?._id}`)
                            } // Adjust route as needed
                          >
                            <Icon
                              icon="majesticons:eye-line"
                              className="icon text-xl"
                            />
                            <span className="tooltip-text">View</span>
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="11" className="text-center">
                      No marketplace listings found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <Paggination
            total={data?.total || 0}
            totalPages={data?.totalPages || 0}
            currentPage={data?.currentPage || 0}
            setPageNo={setPageNo}
            startFrom={(data?.currentPage - 1) * query.limitVal + 1}
            endTo={
              (data?.currentPage - 1) * query.limitVal + data?.data?.length
            }
          />
        </div>
      </div>
    </>
  );
};

export default NftMarketplaceLayer;
